<div class="payment-method-description-container flex justify-center items-center sm:mt-12 mt-6 mb-2 w-full mat-typography" *ngIf="!otpSubmitted">
    <p class="payment-method-description md:text-lg lg:text-lg xl:text-md w-3/5 text-center mb-0">
        Enter the OTP sent to your registered mobile number
    </p>
</div>

<div class="payment-method-description-container flex justify-center items-center sm:mt-12 mt-6 mb-2 w-full" *ngIf="otpSubmitted">
    <p class="payment-method-description md:text-lg lg:text-lg xl:text-md w-3/5 text-center mb-0">
        Verifying your OTP...
    </p>
</div>

<div class="w-full flex justify-center items-center">
    <div class="flex bg-gray-300 justify-center items-center min-h-100 sm:p-6 pb-2 w-3/4" [ngStyle]="{'justify-content': paymentOptionsLoadedJustify, 'border-radius': '12px'}">
        <div *ngIf="loading">
            <mat-spinner
                class="loading-spinner"
                [color]="color"
                [diameter]="diameter"
            >
            </mat-spinner>
        </div>

        <div *ngIf="!loading">
            <form>
                <div class="otp-container flex justify-center w-full">
                    <mat-form-field appearance="standard" class="w-11/12">
                        <mat-label>Enter One-Time Pin</mat-label>
                        <input
                        matInput
                        (click)="resetValidation()"
                        [formControl]="otp"
                        required
                        [errorStateMatcher]="matcher"
                        >
                        <mat-error *ngIf="showErrors">
                            Please enter {{(otpControl.value.name ? otpControl.value.name : 'a valid otp')| lowercase}}.
                        </mat-error>
                    </mat-form-field>
                </div>
            </form>

          <div class="button-container flex justify-center" [ngClass]="mobile ? 'flex-col-reverse' : 'flex-row'">
            <div class="flex justify-center items-center flex-col confirm-container" [ngClass]="mobile ? 'mr-0 mb-1' : 'mr-4 mb-4'">
              <button [disabled]="loading" class="text-xl font-medium rounded-lg continue-button pl-12 pr-12 flex items-center mt-2" [ngStyle]="{'height': '48px', 'color': 'black',  'border': '3px solid ' + headerColor }" mat-button (click)="cancelTransaction()">
                <p class="p-0 m-0">CANCEL</p>
              </button>
            </div>
            <div class="flex justify-center items-center flex-col confirm-container">
              <button class="text-lg text-white h-12 mt-2 rounded-lg w-48" [ngStyle]="{'background-color': headerColor}" (click)="enteredOTP()" [ngClass]="mobile ? 'mr-0 mb-1' : 'mb-4'">
                <strong>CONTINUE</strong>
              </button>
            </div>

          </div>
          <span class="flex justify-center w-full" [ngClass]="mobile ? 'flex-col-reverse' : 'flex-row'">Time remaining: {{ uxFriendlyTime(timeRemaining) }}</span>


        </div>
    </div>
</div>

<div class="payment-method-description-container flex justify-center items-center mt-2 w-full mb-8" *ngIf="!otpSubmitted">

    <div *ngIf="!otpLoading" class="flex items-center hpx-50 mb-3">
        <p class="payment-method-description md:text-lg lg:text-lg xl:text-md w-full text-center mt-3">
            Still waiting on your OTP?
        </p>
        <a target="_blank"
        mat-stroked-button class="overflow-hidden text-xs w-24 back-button justify-center items-center ml-2" [ngStyle]="{'color': headerColor}" (click)="resendOTP()">
        Resend
        </a>
    </div>


    <div class="m-4" *ngIf="otpLoading">
        <mat-spinner
        class="loading-spinner"
        [color]="color"
        [diameter]="otpSpinnerDiameter"
        >
        </mat-spinner>
    </div>

</div>
